import { LeftOutlined } from '@ant-design/icons';
import { Button } from 'components';
import { theme } from 'configs/styled';
import { useQueryParams } from 'hooks/useQueryParams';
import React from 'react';

export interface IReturnButtonProps {}

const ReturnButton: React.FC<IReturnButtonProps> = () => {
  const { search, pushUrl } = useQueryParams();

  const handleClickReturn = () => {
    pushUrl('/', search);
  };

  return (
    <Button
      style={{ marginBottom: theme.spacing.xl }}
      onClick={handleClickReturn}
      icon={<LeftOutlined />}
    >
      กลับหน้าแรก
    </Button>
  );
};

export default ReturnButton;
